<template>
  <tr>
    <td class="text-center">{{ idx + 1 }}</td>
    <td>
        <select class="form-control" v-model="mark.subjectId" id="subjectId" @change="setMarkSubject">
            <option value="">select</option>
            <option v-for="subject in subjectList" :key="subject.subjectId" :value="subject.subjectId">{{ subject.subjectName }}</option>
        </select>
    </td>
    <td>{{mark.subjectName}}</td>
    <td class="text-center">{{ mark.maxMark }}</td>
    <td class="text-center">
        <input type="text" class="form-control" v-model="mark.markObtained" />
    </td>
</tr>
</template>

<script>
/* eslint-disable */
export default {
  name: "markentry-row",
  props:{
      subjectList:{
          type:Array,
          default(){
              return []
          }
      },
      mark:Object,
      idx:Number
  },
  methods:{
      setMarkSubject(){
          const self=this;
          const subject =self.subjectList.find(function (o) { return o.subjectId == self.mark.subjectId; });
          console.log(self.subject);
          self.mark.subjectName=subject.subjectName;
          self.mark.maxMark=subject.maxMark;
      }
  }
}
</script>

<style>

</style>